import { REST } from './utils';

const { GET: GET_PROFILE } = REST('/profile');
const { GET: GET_USERPROFILE, POST: POST_USERPROFILE } = REST('/userprofile');

const PROFILE_AFFILIATIONS_LIMIT = 20;

export const getAlerts = (): Promise<{ alerts: Alert[]; emails: string[]; notificationEmail: string }> =>
    GET_USERPROFILE('/alerts/');

export const saveAlerts = (alerts): Promise<boolean | Error> => POST_USERPROFILE('/alerts/', alerts);

export type ProfileUrlData = {
    error?: Error;
    url?: string;
};

export async function getProfileUrl(): Promise<ProfileUrlData> {
    try {
        return { url: await GET_PROFILE('/url') };
    } catch (error) {
        return { error };
    }
}

export const getProfileInformation = async (): Promise<Profile> => {
    return await GET_USERPROFILE('/profileInfo/');
};

export const getAffiliations = async (): Promise<Affiliation[]> => {
    const affiliations = await GET_USERPROFILE('/affiliations/');
    return (affiliations || []).slice(0, PROFILE_AFFILIATIONS_LIMIT);
};
